// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
  computed,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownMenuComponent, DropdownMenuItem, DropdownMenuClickEvent } from '@lfx/shared/components/dropdown-menu';

@Component({
  selector: 'lfx-workspace-settings',
  imports: [CommonModule, DropdownMenuComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <lfx-dropdown-menu
      triggerSvgIcon="assets/img/svgs/settings.svg"
      triggerAriaLabel="Workspace settings"
      triggerSize="small"
      [items]="menuItems()"
      (itemClicked)="onMenuItemClicked($event)">
    </lfx-dropdown-menu>
  `,
  styleUrls: ['./workspace-settings.component.scss'],
})
export class WorkspaceSettingsComponent {
  readonly workspaceId = input<string>('');
  readonly workspaceName = input<string>('');

  readonly renameWorkspace = output<{ id: string; name: string }>();
  readonly deleteWorkspace = output<{ id: string; name: string }>();

  // Configure dropdown menu items
  protected readonly menuItems = computed<DropdownMenuItem[]>(() => [
    {
      id: 'rename',
      label: 'Rename workspace',
      icon: 'far fa-edit',
      action: 'rename',
      variant: 'default'
    },
    {
      id: 'delete',
      label: 'Delete workspace',
      icon: 'far fa-trash',
      action: 'delete',
      variant: 'danger'
    }
  ]);

  protected onMenuItemClicked(event: DropdownMenuClickEvent): void {
    const workspaceData = {
      id: this.workspaceId(),
      name: this.workspaceName()
    };

    switch (event.action) {
      case 'rename':
        this.renameWorkspace.emit(workspaceData);
        break;
      case 'delete':
        this.deleteWorkspace.emit(workspaceData);
        break;
      default:
        console.warn('Unknown workspace action:', event.action);
    }
  }
}
